import { ErrorPayload } from '@/commons/types'
import { Action, Module, VuexModule } from 'vuex-class-modules'
import $ from 'jquery'

@Module({ generateMutationSetters: true })
export default class Error extends VuexModule {
    private isError = false
    private errorTitleTranslationKey = ''
    private messageTranslationKeys: Array<string> = []
    private errorCode = ''

    @Action
    setError (errorPayload: ErrorPayload): void {
        if (!this.isError) {
            this.isError = true
            $('#errorModal').modal('show')
        }
        this.errorTitleTranslationKey = errorPayload.errorTitleTranslationKey
        this.messageTranslationKeys = errorPayload.messageTranslationKeys
        this.errorCode = errorPayload.errorCode
    }

    get getErrorTitleTranslationKey (): string {
        return this.errorTitleTranslationKey
    }

    get getMessageTranslationKeys (): Array<string> {
        return this.messageTranslationKeys
    }

    get getIsError (): boolean {
        return this.isError
    }

    get getErrorCode (): string {
        return this.errorCode
    }

    @Action
    clear (): void {
        this.isError = false
        this.messageTranslationKeys = []
        this.errorTitleTranslationKey = ''
    }
}
